import { useState } from 'react';
import Modal from './Modal';
import './ForgotPasswordModal.css';

export default function ForgotPasswordModal({ isOpen, onClose, onSubmit }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onSubmit(email);
    setLoading(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Passwort zurücksetzen">
      <form onSubmit={handleSubmit} className="forgot-password-form">
        <p className="forgot-password-info">
          Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.
        </p>
        
        <div className="form-group">
          <label htmlFor="reset-email">E-Mail-Adresse</label>
          <input
            type="email"
            id="reset-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="email@bentomax.de"
            required
            autoFocus
            autoComplete="email"
          />
        </div>

        <div className="modal-actions">
          <button type="button" onClick={onClose} className="cancel-button" disabled={loading}>
            Abbrechen
          </button>
          <button type="submit" disabled={loading}>
            {loading ? 'Wird gesendet...' : 'Link senden'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
